import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import { Tabs, View } from '@zinc/ui';
import { useMediator } from 'bz-utilities/hooks/mediator';
import type { IEvent } from 'bz-utilities/modules/plugins/register/stores/mediator';
import { type PropsWithChildren, useEffect, useState } from 'react';
import styles from './styles';
export interface ISubHeaderProps extends PropsWithChildren, WithStyles<typeof styles> {
  'data-testid'?: string;
  hasActions?: boolean;
  hasTabs?: boolean;
  options?: React.ReactNode;
  style?: React.CSSProperties;
  initialSelectedTab?: string;
}
export class TabEvent implements IEvent {
  name?: string;

  constructor(name?: string) {
    this.name = name;
  }
}

function SubHeader({
  classes,
  children,
  hasTabs,
  'data-testid': dataTest,
  options,
  style,
  initialSelectedTab
}: ISubHeaderProps) {
  const [selectedTab, setSelectedTab] = useState<string | undefined>(initialSelectedTab);

  useMediator(TabEvent, (e) => {
    setSelectedTab(e.name);
  });
  return (
    <View
      data-testid={dataTest || 'subheader'}
      padding={4}
      backgroundColor="page-faded"
      direction="row-reverse"
      grow
    >
      <div className={classes.options}>{options}</div>
      {hasTabs ? (
        <View grow className="min-w-0 overflow-hidden">
          <Tabs
            variant="pills-elevated"
            value={selectedTab}
            onChange={(e) => setSelectedTab(e.value)}
          >
            <Tabs.List>{children}</Tabs.List>
          </Tabs>
        </View>
      ) : (
        <>
          <View grow />
          {children}
        </>
      )}
    </View>
  );
}

export default withStyles(styles)(SubHeader);
